import { SocketConnection } from './SocketConnection';
var socket = {
    create: function (config) {
        if (config === void 0) { config = {}; }
        var socketConnection = {};
        var connect = function (name, url, classType) {
            if (socketConnection[name]) {
                socketConnection[name].disconnect();
            }
            if (classType) {
                socketConnection[name] = new SocketConnection(url).as(classType);
            }
            else {
                socketConnection[name] = new SocketConnection(url);
            }
            return socketConnection[name];
        };
        var disconnect = function (name) {
            if (socketConnection[name]) {
                socketConnection[name].disconnect();
                delete socketConnection[name];
            }
        };
        var getConnection = function (name) { return socketConnection[name] || null; };
        var disconnectAll = function () {
            for (var name_1 in socketConnection) {
                disconnect(name_1);
            }
        };
        return { config: config, connect: connect, disconnect: disconnect, getConnection: getConnection, disconnectAll: disconnectAll };
    },
};
export default socket;
//# sourceMappingURL=index.js.map